import { ChangeDetectionStrategy, Component, EventEmitter, Injector, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, NgControl, UntypedFormControl, ValidationErrors, Validators } from '@angular/forms';
import { BehaviorSubject, Observable, map, startWith } from 'rxjs';
import { CountriesService } from 'src/app/services/countries.service';
import { CountryModel } from 'src/app/shared/models/CountryModel';
import { PhoneNumberPipe } from 'src/app/shared/pipes/PhoneNumber.pipe';
import { AutoCompleteModule } from 'primeng/autocomplete';

@Component({
  selector: 'terra-phone-country-picker',
  templateUrl: './phone-country-picker.component.html',
  styleUrls: ['./phone-country-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: PhoneCountryPickerComponent,
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: PhoneCountryPickerComponent,
      multi: true
  }
  ]
})
export class PhoneCountryPickerComponent implements OnInit, ControlValueAccessor  {
  public phoneForm: FormGroup;
  @Output() countryChanged = new EventEmitter<number>();
  @Input() isOuterFormSubmitted: boolean = false;
  countries: any[] | undefined;
  filteredCountries: any[] | undefined;
  private onTouched: () => void;
  private onChange: (value: {prefix: CountryModel, phone: string}) => void;

  constructor(private countriesService: CountriesService,private formBuilder:FormBuilder) 
  {
  }

  ngOnInit(): void {
    this.countries = this.countriesService.allCountries.slice().filter(c=>c.showInPhonePicker);
    this.phoneForm = this.formBuilder.group({
      prefix: [null, Validators.required],
      phone: [null, [Validators.required, Validators.pattern(`^[0-9]*$`)]],
  });
  }

  filterCountry(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.countries as any[]).length; i++) {
        let country = (this.countries as any[])[i];
        if (country.showInPhonePicker && (country.defaultCountryCallingCode.startsWith(query) ||country.defaultCountryCallingCode.slice(1).startsWith(query)|| country.name.toLowerCase().startsWith(query.toLowerCase()) || country.code.toLowerCase().startsWith(query.toLowerCase()))) {
            filtered.push(country);
        }
    }
    this.filteredCountries = filtered;
  }

  countrySelected(event: any) {
    this.countryChanged.emit(event?.value);
  }

  writeValue(obj: any): void {
      const form = 
      {
        prefix: obj?.prefix?.defaultCountryCallingCode,
        phone: obj?.phone?.phone
      };
      this.phoneForm.patchValue(form, { emitEvent: false });
      this.phoneForm.updateValueAndValidity();
  }

  registerOnChange(fn: (value: {prefix: CountryModel, phone: string}) => void): void {
    this.phoneForm.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes['isOuterFormSubmitted'] && changes['isOuterFormSubmitted'].previousValue === false || changes['isOuterFormSubmitted'].currentValue == null) {
      Object.values(this.phoneForm.controls).forEach(control => {control.markAsTouched(); control.markAsDirty()});
    }
  }

  validate(control: AbstractControl): ValidationErrors {
    return this.phoneForm.valid ? null : { invalidForm: { valid: false, errors: this.phoneForm.errors } };
  }

  registerOnValidatorChange?(fn: () => void): void { }
  }
